module.exports = __webpack_public_path__ + "h5/img/huodong_5.225d0c59.jpg";